import WrapperService from '@/modules/core/services/wrapper-service';
import {createPageableParams} from '@/modules/core/services/table-utils';

const settingsServiceName = "Option-Service: ";
const OPTION_API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/option';

export default class OptionService {

    static async readAllOptionsPaginated(page, size, search, sort, sortAsc, successF, errorF) {
        let params = createPageableParams(page, size, search, sort, sortAsc, successF, errorF, ['name'], ['name']);
        await WrapperService.get(OPTION_API_URL + '/page?' + params, null, settingsServiceName, successF, errorF);
    }

    static async saveOption(option, successF, errorF) {
        if (typeof option.id === 'undefined' || option.id === null) {
            await WrapperService.post(OPTION_API_URL, option, settingsServiceName, successF, errorF);
        } else {
            await WrapperService.put(OPTION_API_URL + '/' + option.id, option, settingsServiceName, successF, errorF);
        }
    }

    static async hasRotationOption(successF, errorF) {
        await WrapperService.get(OPTION_API_URL + '/has/rotation', null, settingsServiceName, successF, errorF);
    }
}
